import { espelhoPeriodo } from './endpoints/espelho-periodo'

/**
 * Serviços que devem recarregar seus dados quando o backend avisa que algo
 * mudou fora do fluxo normal de mutação — jobs em fila, principalmente.
 *
 * O backend emite uma notificação silenciosa `{ module, type: 'cache-update' }`
 * e a chave aqui é o `module`.
 */
const servicosPorModulo = {
    'espelho-periodo': espelhoPeriodo,
} satisfies Record<string, { invalidateQueries: () => Promise<void> }>

export function invalidarCacheDoModulo(module: string) {
    const servico =
        servicosPorModulo[module as keyof typeof servicosPorModulo] ?? null

    return servico?.invalidateQueries()
}
